module.exports = __webpack_public_path__ + "img/clickmapmarker.5dfd4b29.svg";